export enum OptionType {
  ADD = 0,
  MULTIPLY = 1,
  SIZE = 2,
  PRODUCT = 3,
  DISCOUNT_PERCENTAGE = 4,
  DISCOUNT_AMOUNT = 5,
  REMOVABLE = 6,
}

export function getOptionType(type: number): OptionType {
  switch (type) {
    case OptionType.MULTIPLY:
      return OptionType.MULTIPLY;
    case OptionType.SIZE:
      return OptionType.SIZE;
    case OptionType.PRODUCT:
      return OptionType.PRODUCT;
    case OptionType.DISCOUNT_PERCENTAGE:
      return OptionType.DISCOUNT_PERCENTAGE;
    case OptionType.DISCOUNT_AMOUNT:
      return OptionType.DISCOUNT_AMOUNT;
    case OptionType.REMOVABLE:
      return OptionType.REMOVABLE;
    case OptionType.ADD:
    default:
      return OptionType.ADD;
  }
}

export function isDiscountOptionType(type: number): boolean {
  return type === OptionType.DISCOUNT_PERCENTAGE || type === OptionType.DISCOUNT_AMOUNT;
}

export function formatMultiplier(modifier: number): string {
  if (typeof modifier !== 'number' || isNaN(modifier)) return '1';
  return modifier % 1 === 0 ? modifier.toFixed(0) : modifier.toFixed(2);
}
